export default [
  {
    path: '/suppliers',
    name: 'supplier-list',
    props: true,
    component: () => import('@/views/users/suppliers/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Liste des Fournisseurs',
      pageDesc: 'Consultez, filtrez et gérez les fournisseurs logistiques. Utilisez les filtres pour affiner la liste et accédez aux détails de chaque fournisseur.',
      ariaLabel: 'Tableau des fournisseurs logistiques',
      breadcrumb: [
        {
          text: 'Fournisseurs',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des fournisseurs',
        },
        {
          text: 'Liste des Fournisseurs',
          active: true,
          ariaLabel: 'Page active : liste des fournisseurs',
        },
      ],
      breadcrumbLabel: 'Liste des Fournisseurs',
      // Allow superadmin to view suppliers list (read-only on UI)
      roles: ['admin', 'manager', 'sales', 'superadmin'],
    },
  },
  {
    path: '/suppliers/create',
    name: 'supplier-add',
    props: true,
    component: () => import('@/views/users/suppliers/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Ajouter un Fournisseur',
      pageDesc: 'Ajoutez un nouveau fournisseur logistique en renseignant les informations professionnelles, coordonnées et tarification.',
      ariaLabel: 'Formulaire d’ajout de fournisseur',
      breadcrumb: [
        {
          text: 'Fournisseurs',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des fournisseurs',
        },
        {
          text: 'Ajouter fournisseur',
          active: true,
          ariaLabel: 'Page active : ajout fournisseur',
        },
      ],
      breadcrumbLabel: 'Ajouter fournisseur',
      roles: ['admin', 'sales'],
    },
  },
  {
    path: '/suppliers/edit/:id',
    name: 'supplier-edit',
    props: true,
    component: () => import('@/views/users/suppliers/Edit.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Modifier un Fournisseur',
      pageDesc: 'Modifiez les informations professionnelles, coordonnées et tarification du fournisseur sélectionné.',
      ariaLabel: 'Formulaire de modification de fournisseur',
      breadcrumb: [
        {
          text: 'Fournisseurs',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des fournisseurs',
        },
        {
          text: 'Modifier fournisseur',
          active: true,
          ariaLabel: 'Page active : modification fournisseur',
        },
      ],
      breadcrumbLabel: 'Modifier fournisseur',
      roles: ['admin', 'sales'],
    },
  },
  {
    path: '/suppliers/show/:id',
    name: 'supplier-show',
    props: true,
    component: () => import('@/views/users/suppliers/Show.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Détails du Fournisseur',
      pageDesc: 'Consultez les informations détaillées, statistiques et commandes du fournisseur sélectionné.',
      ariaLabel: 'Détails du fournisseur logistique',
      breadcrumb: [
        {
          text: 'Fournisseurs',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des fournisseurs',
        },
        {
          text: 'Détails fournisseur',
          active: true,
          ariaLabel: 'Page active : détails fournisseur',
        },
      ],
      breadcrumbLabel: 'Détails fournisseur',
      // Allow superadmin to open supplier details (read-only)
      roles: ['admin', 'manager', 'sales', 'superadmin'],
    },
  },
  {
    path: '/suppliers/:id/change-password',
    name: 'supplier-change-password',
    component: () => import('@/views/users/suppliers/ChangePassword.vue'),
    meta: {
      pageTitle: 'Changer le mot de passe',
      pageDesc: 'Modifiez le mot de passe d’accès du fournisseur sélectionné. Utilisez un mot de passe sécurisé.',
      ariaLabel: 'Formulaire de changement de mot de passe fournisseur',
      breadcrumb: [
        {
          text: 'Fournisseurs',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des fournisseurs',
        },
        {
          text: 'Détail fournisseur',
          to: { name: 'supplier-show', params: { id: null } },
          paramId: 'id',
          ariaLabel: 'Retour au détail fournisseur',
        },
        {
          text: 'Changer le mot de passe',
          active: true,
          ariaLabel: 'Page active : changement mot de passe',
        },
      ],
      breadcrumbLabel: 'Changer le mot de passe',
      requireLogin: true,
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/support-center',
    name: 'supplier-support-center',
    component: () => import('@/views/SupplierSupportCenter.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Centre de Support',
      pageDesc: 'Signalez des bugs, demandez des fonctionnalités ou obtenez une assistance technique',
      ariaLabel: 'Centre de support fournisseur',
      breadcrumb: [
        {
          text: 'Centre de Support',
          active: true,
          ariaLabel: 'Page active : centre de support',
        },
      ],
      breadcrumbLabel: 'Centre de Support',
      roles: ['supplier'],
    },
  },
]
